import { ActivatedRouteSnapshot } from '@angular/router';
import { View } from '../../layout/model/interfaces/view.interface';

export function buildLegacyIframeView(
  route: ActivatedRouteSnapshot | undefined,
  routeName: string,
  basePath: string,
): View {
  const workflowId = route?.paramMap?.get('workflowId');
  const queryParams = route?.queryParams || {};
  let queryString = '';

  if (queryParams && Object.keys(queryParams).length > 0) {
    const params = new URLSearchParams();
    for (const key in queryParams) {
      if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
        params.append(key, queryParams[key]);
      }
    }
    queryString = '?' + params.toString();
  }

  let iframeUrl = '';
  if (workflowId) {
    iframeUrl = `${basePath}/${workflowId}${queryString}`;
  } else {
    iframeUrl = `${basePath}${queryString}`;
  }

  return {
    route: routeName,
    iframeUrl: iframeUrl,
  };
}
